import React, { useState, useEffect } from 'react';
import { ImSpinner2 } from 'react-icons/im';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { useAppStore } from '../../../../../../../GlobalStore/GlobalStore';

interface ExpandHeaderProps {
    icon: React.ReactNode;
    title: string;
    isExpanded: boolean;
    isInProgress: boolean;
    onClick: () => void;
    stage?: {
        current: number;
        total: number;
        label: string;
    };
}

interface LoadingSpinnerProps {
    stage?: ExpandHeaderProps['stage'];
}

const AnimatedDots: React.FC = () => {
    const [dots, setDots] = useState(1);

    useEffect(() => {
        const interval = setInterval(() => {
            setDots(prev => prev === 3 ? 1 : prev + 1);
        }, 500);

        return () => clearInterval(interval);
    }, []);

    return <span>{'.'.repeat(dots)}</span>;
};

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ stage }) => (
    <div className="flex items-center justify-center">
        <ImSpinner2 className="animate-spin text-blue-500 ml-2" />
        {stage && (
            <span className="ml-2 text-sm text-neutral-500">
                ({stage.current}/{stage.total}) {stage.label.charAt(0).toUpperCase() + stage.label.slice(1)}<AnimatedDots />
            </span>
        )}
    </div>
);

export const ExpandHeader: React.FC<ExpandHeaderProps> = ({
    icon,
    title,
    isExpanded,
    isInProgress,
    onClick,
    stage
}) => (
    <div
        className="flex items-center mb-1 cursor-pointer ml-2"
        onClick={onClick}
    >
        {icon}
        <span className="font-medium text-neutral-600 dark:text-neutral-300">{title}</span>
        {isInProgress ? (
            <LoadingSpinner stage={stage} />
        ) : (
            isExpanded ? (
                <FaChevronUp className="ml-2 text-neutral-500" size={12} />
            ) : (
                <FaChevronDown className="ml-2 text-neutral-500" size={12} />
            )
        )}
    </div>
);

export const ToolCallWrapper: React.FC<{children: React.ReactNode}> = ({ children }) => {
    const environmentObj = useAppStore((state: any) => state.environmentObj);
    const { environment } = environmentObj;

    return (
        <div className={`${environment === "vscode" ? "text-xs py-2" : "text-sm py-3"} text-neutral-600 dark:text-neutral-400`}>
            {children}
        </div>
    );
}


export const ExpandedContent: React.FC<{children: React.ReactNode}> = ({ children }) => (
    <div className="pl-6 mt-1 space-y-6">
        {children}
    </div>
);